import createIcon from '../../createIcon';

/**
 * @component @name BorderLeft
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTEgMjFIMTNWMTlIMTFWMjFaTTExIDE3SDEzVjE1SDExVjE3Wk0xMSA1SDEzVjNIMTFWNVpNMTEgOUgxM1Y3SDExVjlaTTExIDEzSDEzVjExSDExVjEzWk03IDIxSDlWMTlIN1YyMVpNNyA1SDlWM0g3VjVaTTcgMTNIOVYxMUg3VjEzWk0zIDIxSDVWM0gzVjIxWk0xOSA5SDIxVjdIMTlWOVpNMTUgMjFIMTdWMTlIMTVWMjFaTTE5IDE3SDIxVjE1SDE5VjE3Wk0xOSAzVjVIMjFWM0gxOVpNMTkgMTNIMjFWMTFIMTlWMTNaTTE5IDIxSDIxVjE5SDE5VjIxWk0xNSAxM0gxN1YxMUgxNVYxM1pNMTUgNUgxN1YzSDE1VjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const BorderLeft = createIcon('BorderLeft', [
  [
    'path',
    {
      d: 'M11 21H13V19H11V21ZM11 17H13V15H11V17ZM11 5H13V3H11V5ZM11 9H13V7H11V9ZM11 13H13V11H11V13ZM7 21H9V19H7V21ZM7 5H9V3H7V5ZM7 13H9V11H7V13ZM3 21H5V3H3V21ZM19 9H21V7H19V9ZM15 21H17V19H15V21ZM19 17H21V15H19V17ZM19 3V5H21V3H19ZM19 13H21V11H19V13ZM19 21H21V19H19V21ZM15 13H17V11H15V13ZM15 5H17V3H15V5Z',
      key: 'grv3pp',
    },
  ],
]);

export default BorderLeft;
